/**
 * No-op Analytics Client
 *
 * Logs to console in development, no-ops in production.
 * Useful for testing or when no analytics provider is configured.
 */

import type { AnalyticsClient } from './types';

const isDev = process.env.NODE_ENV === 'development';

export const noopAnalyticsClient: AnalyticsClient = {
	init: () => {
		if (isDev) console.log('[Analytics] noop client initialized');
	},
	track: (eventName, properties) => {
		if (isDev) console.log(`[Analytics] ${eventName}`, properties);
	},
	identify: (userId, properties) => {
		if (isDev) console.log('[Analytics] identify', { userId, ...properties });
	},
	setPersonProperties: (properties) => {
		if (isDev) console.log('[Analytics] setPersonProperties', properties);
	},
	group: (groupType, groupKey, properties) => {
		if (isDev) console.log('[Analytics] group', { groupType, groupKey, ...properties });
	},
	reset: () => {
		if (isDev) console.log('[Analytics] reset user');
	},
};
